<template>
  <el-date-picker
      class="j-date"
      popper-class="j-date-popper-wrap"
      :type="type"
      v-model="date"
      v-bind="$attrs"
      v-on="$listeners"
      :clearable="clearable"
      :value-format="valueFormat"
      :picker-options="pickerOptions"
  />
</template>

<script>
import moment from "moment";
export default {
  name: 'JDate',
  props: {
    type: { // year/month/date/datetime
      type: String,
      default: 'date'
    },
    beforeShortcuts: { // [7,30,90]
      type: Array,
      default: () => []
    },
    afterShortcuts: { // [7,30,90]
      type: Array,
      default: () => []
    },
    disabledRange: { // ['', 'before', 'after', 'before-today', 'after-today']
      type: String,
      default: ''
    },
    disabledDate: { // 禁用一个具体日期配合disabledRange使用
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    valueFormat: { // 'yyyy-MM-dd HH:mm:ss'
      type: String,
      default: 'yyyy-MM-dd'
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      date: '',
      pickerOptions: {
        shortcuts: null,
        disabledDate: null
      }
    }
  },
  created () {
    if (this.value) {
      // 默认格式化
      this.date = moment(this.value).format(this.valueFormat.replace('dd', 'DD'))
    } else {
      this.date = ''
    }
    this.updateDisabledRange(this.disabledRange) // 时间段限制
    // 快捷时间
    this.shortcutBeforeTime()
    this.shortcutAfterTime()
  },
  methods: {
    updateDisabledRange (disabledRange) {
      if (disabledRange === 'before') this.pickerOptions['disabledDate'] = this.disableBefore
      else if (disabledRange === 'after') this.pickerOptions['disabledDate'] = this.disableAfter
      else if (disabledRange === 'before-today') this.pickerOptions['disabledDate'] = this.disableBeforeToday
      else if (disabledRange === 'after-today') this.pickerOptions['disabledDate'] = this.disableAfterToday
      else this.pickerOptions['disabledDate'] = null
    },
    shortcutBeforeTime () {
      if (this.beforeShortcuts.length < 1) return
      if (!this.pickerOptions.shortcuts) this.pickerOptions.shortcuts = []
      if (this.type === 'year') {
        this.beforeShortcuts.forEach(year => {
          this.pickerOptions.shortcuts.push({
            text: `过去${year}年`,
            onClick(picker) {
              const date = new Date();
              date.setFullYear(date.getFullYear() - year);
              picker.$emit('pick', date);
            }
          })
        })
      } else if (this.type === 'month') {
        this.beforeShortcuts.forEach(month => {
          this.pickerOptions.shortcuts.push({
            text: `过去${month}个月`,
            onClick(picker) {
              const date = new Date();
              date.setMonth(date.getMonth() - month);
              picker.$emit('pick', date);
            }
          })
        })
      } else {
        this.beforeShortcuts.forEach(day => {
          this.pickerOptions.shortcuts.push({
            text: `过去${day}天`,
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * Number(day || 1))
              picker.$emit('pick', date)
            }
          })
        })
      }
    },
    shortcutAfterTime () {
      if (this.afterShortcuts.length < 1) return
      if (!this.pickerOptions.shortcuts) this.pickerOptions.shortcuts = []
      if (this.type === 'year') {
        this.afterShortcuts.forEach(year => {
          this.pickerOptions.shortcuts.push({
            text: `未来${year}年`,
            onClick(picker) {
              const date = new Date();
              date.setFullYear(date.getFullYear() + year);
              picker.$emit('pick', date);
            }
          })
        })
      } else if (this.type === 'month') {
        this.afterShortcuts.forEach(month => {
          this.pickerOptions.shortcuts.push({
            text: `未来${month}个月`,
            onClick(picker) {
              const date = new Date();
              date.setMonth(date.getMonth() + month);
              picker.$emit('pick', date);
            }
          })
        })
      } else {
        this.afterShortcuts.forEach(day => {
          this.pickerOptions.shortcuts.push({
            text: `未来${day}天`,
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * Number(day || 1))
              picker.$emit('pick', date)
            }
          })
        })
      }
    },
    disableBefore (time) {
      const date = this.disabledDate ? moment(this.disabledDate).endOf('day').format('x') : Date.now()
      return time.getTime() < (date - 24 * 60 * 60 * 1000)
    },
    disableAfter (time) {
      const date = this.disabledDate ? moment(this.disabledDate).endOf('day').format('x') : Date.now()
      return time.getTime() > date
    },
    disableBeforeToday (time) {
      const date = this.disabledDate ? moment(this.disabledDate).endOf('day').format('x') : Date.now()
      return time.getTime() < date
    },
    disableAfterToday (time) {
      const date = this.disabledDate ? moment(this.disabledDate).endOf('day').format('x') : Date.now()
      return time.getTime() > (date - 24 * 60 * 60 * 1000)
    }
  },
  watch: {
    disabledDate () {
      this.updateDisabledRange(this.disabledRange)
    },
    disabledRange (nv) {
      this.updateDisabledRange(nv)
    },
    value (nv) {
      this.date = nv || ''
    }
  }
}
</script>

<style lang="scss">
.j-date {
  width: 100%;
}
.j-date-popper-wrap { // 时间范围时修正滚动条显示问题
  .el-time-spinner__wrapper {
    overflow: hidden;
  }
}
</style>
